// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Compponent: React.LazyExoticComponent<any> = React.lazy(() => import('../components/Dashboard'));

export default class Dashboard extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        title: 'Custom Dashboard',
        active: true,
        component: Compponent,
        props: {
          report: 'DASHBOARD_CUSTOM',
          title: 'Dashboard Custom',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
